import { Tabs, Page, Card, Box } from "@shopify/polaris";
import { useState, useCallback } from "react";
import ReviewsComponent from "../../Components/ReviewsComponent.js";
import SessionsListComponent from "../../Components/SessionsListComponent.js";

const PastAndUpcomingSessions = () => {
  const [selected, setSelected] = useState(0);

  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    []
  );

  const tabs = [
    {
      id: "past-sessions",
      content: "Past Sessions",
    },
    {
      id: "upcoming-sessions",
      content: "Upcoming Sessions",
    },
  ];

  return (
    <Page title="Sessions" fullWidth>
      <Card padding={200}>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange} fitted>
          {selected === 0 ? (
            <SessionsListComponent type="past" />
          ) : (
            <SessionsListComponent type="incoming" />
          )}
        </Tabs>
      </Card>
    </Page>
  );
};

export default PastAndUpcomingSessions;
